import * as React from "react";

import styles from "./ServerFavicon.module.css";

interface ServerFaviconProps {
  issuerUrl?: string;
  displayName: string;
}

/**
 * Extract the root domain from a URL, stripping subdomains.
 * e.g. "https://accounts.google.com/foo" → "https://google.com"
 */
function getRootOrigin(url: string): string | null {
  try {
    const parsed = new URL(url);
    const parts = parsed.hostname.split(".");
    // Keep last two parts (or the whole thing for localhost / single-label hosts)
    const root = parts.length > 2 ? parts.slice(-2).join(".") : parsed.hostname;
    return `${parsed.protocol}//${root}`;
  } catch {
    return null;
  }
}

export function ServerFavicon({ issuerUrl, displayName }: ServerFaviconProps) {
  const [failed, setFailed] = React.useState(false);

  const rootOrigin = issuerUrl ? getRootOrigin(issuerUrl) : null;

  if (!rootOrigin || failed) {
    return null;
  }

  const faviconUrl = `${rootOrigin}/favicon.ico`;

  return (
    <img
      src={faviconUrl}
      alt={displayName}
      className={styles.favicon}
      onError={() => setFailed(true)}
    />
  );
}
